<div class="floating-input-wrapper"
     [class.focused]="isFocused"
     [class.has-value]="hasValue"
     [class.disabled]="disabled">
  <div class="floating-input-container" (click)="focusInput($event)">
    <input
      #priceInput
      type="text"
      inputmode="numeric"
      autocomplete="off"
      class="floating-input"
      [id]="'field_' + field.code"
      [name]="field.code"
      [disabled]="disabled"
      [required]="required"
      [value]="formattedNumber"
      [attr.size]="formattedNumber.length || 1"
      (focus)="onFocus()"
      (blur)="onBlur()"
      (input)="onInput($event)"
      [placeholder]="placeholder || ' '"
    />
    <span class="price-input-words-inline" *ngIf="words">({{ words }})</span>
    <label class="floating-label" [class.floating]="isFocused || hasValue">
      <img
        src="assets/icons/required-asterisk.svg"
        *ngIf="required"
        [attr.alt]="'alt.requiredField' | translate"
      >
      {{ label }}
    </label>
  </div>
</div>
